/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import { IDateList } from '../../interfaces';
import LayoutInside from '../layout/LayoutInside';
import Card from './Card';
import SliderDate from './SliderDate';
import { dateList } from '../../../common/data/dateList';
import { useLocation } from 'react-router-dom';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}
export default function CardList(props): JSX.Element {
    const { attribute, items, listDetails, filter, origin } = props;
    const [select, setSelect] = useState<IDateList>();
    const [listItems, setListItems] = useState([]);
    //const query = useQuery();
    //const day = query.get('day');
    //const region = query.get('region');
    //const commune = query.get('commune');

    const pathnameAll = window.location.pathname + useLocation().search;
    const search = useLocation().search;
    const pathname = location.pathname.split('/');
    const type = pathname.length > 1 ? pathname[2] : 'arrienda';
    /*const textNameA = `Arrienda ${region ? ` | ${region}` : ``} ${commune ? ` | ${commune}` : ``}`;
    const textNameI = `Integrar ${region ? ` | ${region}` : ``} ${commune ? ` | ${commune}` : ``}`;*/
    const textNameA = `Arrienda | Buscar`;
    const textNameI = `Integrar | Buscar`;
    const textNameD = `Equipos | Buscar`;
    const useQuerys = useQuery();
    const originView = useQuerys.get('originView');

    const breads = [
        {
            key: type === 'arrienda' ? 'Arrienda' : 'Integrar',
            name: type === 'arrienda' ? textNameA : type === 'desafiar' ? textNameD : textNameI,
            url: `/${type}`,
            add: true,
        },
        {
            key:
                type === 'arrienda'
                    ? 'clubes'
                    : type === 'desafiar'
                    ? originView === 'create'
                        ? 'clubes'
                        : 'equipos'
                    : 'partidos',
            name:
                type === 'arrienda'
                    ? 'Clubes'
                    : type === 'desafiar'
                    ? originView === 'create'
                        ? 'Clubes'
                        : 'Equipos'
                    : 'Partidos',
            url: pathnameAll,
            add: false,
        },
    ];

    const breadsDefyClubs = [
        {
            key: 'sport',
            name: textNameD,
            url: `/desafiar`,
            add: true,
        },
        {
            key: 'teams',
            name: 'Equipos',
            url: `/desafiar/equipos/filter${search}`,
            add: true,
        },
        {
            key: 'teasm-create',
            name: 'Partido | Crear',
            url: `/desafiar/equipos/crear${search}`,
            add: true,
        },
        {
            key: 'clubes',
            name: 'Clubes',
            url: pathnameAll,
            add: false,
        },
    ];

    const propCard = {
        hAutoMovil: 'h-auto',
        hAuto: 'lg:h-auto md:h-auto',
        wAutoMovil: '',
        wAuto: '',
        hMovil: 'sm:h-72',
        wMovil: 'w-96',
        h: '',
        hButton: '',
        w: 'lg:w-56 md:w-56',
        widthImage: 224,
        heightImage: 120,
        minWidthImage: 224,
        activeButton: true,
        urlbutton: '/',
        others: 'bg-white p-0 mx-4 my-1 mb-0 rounded-xl shadow-2xl',
        content: 'pt-2 text-center w-full  ',
        card: '',
        activeHoverCard: false,
    };

    useEffect(() => {
        if (select && select.dateFormat && origin === 'integrate' && items && items.length > 0) {
            /* if (parseInt(day) !== select.id && list && list.length > 0) {
                setListItems(list.filter((item) => item.dateFormat === select.dateFormat));
            } else {
                setListItems(items.filter((item) => item.dateFormat === select.dateFormat));
            }*/
            setListItems(items.filter((item) => item.dateFormat === select.dateFormat));
        }
    }, [select]);

    useEffect(() => {
        setListItems(items);
        if (filter.day === '') {
            setSelect(dateList().find((i) => i.active === true));
        }
    }, [items]);

    return (
        <LayoutInside
            attribute={attribute}
            title={listDetails.subTitle}
            subTitle={''}
            breads={type === 'desafiar' ? breadsDefyClubs : breads}
        >
            <div className={`container mx-auto`}>
                <div className={`flex-col py-2`} role={listDetails.title}>
                    <div className="mx-auto w-full md:flex lg:flex justify-center items-center ">
                        <div className="w-full">
                            <SliderDate attribute={attribute} select={select} setSelect={setSelect} />
                        </div>
                    </div>
                </div>
                <div className={`flex-col py-2`}>
                    <div className="w-full flex justify-center items-center md:space-x-10">
                        <div
                            className={`hidden md:grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5  justify-center items-center`}
                        >
                            {listItems &&
                                listItems.length > 0 &&
                                listItems.map((item, i) => (
                                    <div key={`card-list-${i}`} className="flex-col p-1 md:p-0">
                                        <div className="flex justify-center content-center py-0 px-0 md:py-2  md:px-4 lg:py-2 lg:px-4">
                                            <Card
                                                details={item}
                                                attribute={attribute}
                                                propCard={propCard}
                                                filter={select}
                                                type="list-defy"
                                                filterQuery={filter}
                                                origin={origin}
                                            />
                                        </div>
                                    </div>
                                ))}
                        </div>
                        <div className={`grid md:hidden grid-cols-2 justify-center items-center`}>
                            {listItems &&
                                listItems.length > 0 &&
                                listItems.map((item, i) => (
                                    <div key={`card-list-${i}`} className="flex-col p-1 md:p-0">
                                        <div className="flex justify-center content-center py-0 px-0">
                                            <Card
                                                details={item}
                                                attribute={attribute}
                                                propCard={{
                                                    ...propCard,
                                                    widthImage: null,
                                                    minWidthImage: 170,
                                                    heightImage: 120,
                                                }}
                                                filter={select}
                                                type="list"
                                                filterQuery={filter}
                                                origin={origin}
                                            />
                                        </div>
                                    </div>
                                ))}
                        </div>
                        {filter.region !== null && !(listItems && listItems.length > 0 && filter && filter.region) && (
                            <div className="">
                                <div className="flex-col mt-8 pt-8 text-sm text-red-500 font-bold ">
                                    No existe {listDetails.title.toLowerCase()} asociados
                                    <br />
                                    {select && origin === 'integrate' && ` El día  ${select.day}  ${select.date}`}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </LayoutInside>
    );
}
